import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FanPageScreen from "../components/fanPage/FanPageScreen";
import { useGetMyFanPageQuery } from "../store/api/mlbApi";
import { getFanPagePath } from "../utils/fanPage";

const MyLineup = () => {
  const navigate = useNavigate();
  const { data: page, isLoading, error } = useGetMyFanPageQuery();

  return (
    <Box sx={{ maxWidth: 1280, mx: "auto" }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Build it here, share it everywhere.
      </Typography>
      <FanPageScreen
        page={page}
        loading={isLoading}
        error={error}
        errorMessage="Couldn’t load your lineup."
        onPublished={(next) => {
          if (next?.handle) navigate(getFanPagePath(next.handle));
        }}
      />
    </Box>
  );
};

export default MyLineup;
